import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '电影分类',
      links: [
        { label: '爱情片', to: '/category/aiqing' },
        { label: '喜剧片', to: '/category/xiju' },
        { label: '动作片', to: '/category/dongzuo' },
        { label: '悬疑片', to: '/category/xuanyi' },
        { label: '科幻片', to: '/category/kehuan' },
        { label: '动画片', to: '/category/donghua' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '联系我们', to: '/about#contact' },
        { label: '用户口碑', to: '/about#reputation' },
      ],
    },
    {
      title: '热门推荐',
      links: [
        { label: '最新上映', to: '/category/dongzuo' },
        { label: '高分推荐', to: '/category/jilupian' },
        { label: '影评精选', to: '/article/article-001' },
      ],
    },
  ];

  return (
    <footer className="bg-background-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 text-background-50 hover:text-primary-400 transition-colors">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold whitespace-nowrap">
                蜜桃电影
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              蜜桃电影为您精选海量优质影片资源，涵盖多种电影类型，提供高清在线观看推荐。发现好片，从这里开始。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-background-100 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {currentYear} 蜜桃电影 mitaomovie.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors text-sm" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors text-sm" rel="nofollow">服务条款</a>
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors text-sm" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}